<!-- header -->
<sign-up-header></sign-up-header>

<div class="main-content-container">
    <div class="container-spaced">
        <div class="main-container cnt-column-centered g4Border" style="min-width: 500px">
            <div class="cnt-column-centered">
                <div [height]="15"></div>
                <div class="h2Font signin-text b4Color" i18n>
                    {{ 'THE_ACTIVATION_LINK_HAS' | translate }}.
                </div>
            </div>
            <div [height]="40"></div>
            <div class="cnt-column-centered">
                <div>
                    <span class="h2Font signin-text b4Color" i18n>{{ 'PLEASE' | translate }} </span>
                    <span class="termsLabel h2Font" (click)="resendVerificationEmail()" i18n>{{ 'CLICK_HERE' | translate }}</span>
                </div>
                <div>
                    <span class="h2Font signin-text b4Color" i18n>
                        {{ 'TO_RECEIVE_A_NEW' | translate }}.
                    </span>
                </div>
            </div>
            <div [height]="40"></div>
        </div>
    </div>
</div>